import { motion } from "framer-motion";

function FloatingPaths({ position }) {
    // Shift paths upward by reducing the Y offsets (was 189/343, now 300/450)
    // so the lines appear higher in the viewport, aligned with the headline
    const paths = Array.from({ length: 36 }, (_, i) => ({
        id: i,
        d: `M-${380 - i * 5 * position} -${300 + i * 6}C-${
            380 - i * 5 * position
        } -${300 + i * 6} -${312 - i * 5 * position} ${100 - i * 6} ${
            152 - i * 5 * position
        } ${230 - i * 6}C${616 - i * 5 * position} ${360 - i * 6} ${
            684 - i * 5 * position
        } ${700 - i * 6} ${684 - i * 5 * position} ${700 - i * 6}`,
        width: 0.5 + i * 0.03,
        // Light mode: more opaque for visibility. Dark mode handled via CSS opacity on the parent.
        opacity: 0.18 + i * 0.022,
    }));

    return (
        <div className="absolute inset-0 pointer-events-none">
            <svg
                className="w-full h-full"
                viewBox="0 0 696 316"
                fill="none"
            >
                <defs>
                    <linearGradient id={`movii-grad-${position}`} x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#1D4ED8" />
                        <stop offset="50%" stopColor="#2563EB" />
                        <stop offset="100%" stopColor="#60A5FA" />
                    </linearGradient>
                </defs>
                {paths.map((path) => (
                    <motion.path
                        key={path.id}
                        d={path.d}
                        stroke={`url(#movii-grad-${position})`}
                        strokeWidth={path.width}
                        strokeOpacity={path.opacity}
                        initial={{ pathLength: 0.3, opacity: 0.6 }}
                        animate={{
                            pathLength: 1,
                            opacity: [0.4, 0.7, 0.4],
                            pathOffset: [0, 1, 0],
                        }}
                        transition={{
                            duration: 20 + (path.id % 5) * 2,
                            repeat: Infinity,
                            ease: "linear",
                        }}
                    />
                ))}
            </svg>
        </div>
    );
}

/**
 * FloatingPathsBg - SVG animated background for mobile Hero Section.
 * Lines are positioned higher to align with the headline text.
 * A tall bottom fade gradient masks where lines terminate.
 */
export function FloatingPathsBg() {
    return (
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <FloatingPaths position={1} />
            <FloatingPaths position={-1} />
            {/* Tall bottom fade that follows exactly where lines end */}
            <div className="absolute bottom-0 left-0 right-0 h-[55%] bg-gradient-to-t from-slate-50 via-slate-50/80 dark:from-[#030B1A] dark:via-[#030B1A]/80 to-transparent pointer-events-none" />
        </div>
    );
}
